export const PAGE_SIZE = 15
export const MAX_PAGE_SIZE = 99999999
export const AUTHORIZATION_HEADER_PREFIX = 'SessionToken '
export const INDETERMINATE = 'indeterminate'

// Rows per CSV part before an export is split into a zip. Excel opens at most 1,048,576 rows per
// sheet, so 1M data rows plus the header is the largest part a user can still open whole; splitting
// any finer only multiplies the number of files they have to stitch back together.
export const MAX_ROWS_PER_CSV_FILE = 1_000_000
export const MAX_ROWS_FOR_EXPORT = 800000

export const SUPPORT_EMAIL = 'itcanasd@bat.com'

export const NONE_VALUE = 'none'

// Generic Y/N flags used throughout the database
export const YES_NO_FLAG = {
  YES: 'Y',
  NO: 'N',
} as const

export type YesNoFlag = (typeof YES_NO_FLAG)[keyof typeof YES_NO_FLAG]

export const OLD = 'OLD'
export const STARTS_WITH_OLD = `${OLD}%`
